import React from 'react'
import { GuildGiveawayBanner } from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/GiveawayBanners/GuildGiveawayBanner'
import { useGuildBannerLogic } from './hooks/useGuildBannerLogic'

interface GuildBannerWrapperProps {
  className?: string
  theatricalSlug: string
  areGuildTicketsAvailable: boolean
  isPremiumGuildMember: boolean
  promoType?: string
}

export const GuildBannerWrapper: React.FC<GuildBannerWrapperProps> = ({
  className,
  theatricalSlug,
  areGuildTicketsAvailable,
  isPremiumGuildMember,
}) => {
  const { shouldShowGuildGiveaway } = useGuildBannerLogic({
    areGuildTicketsAvailable,
    isPremiumGuildMember,
  })

  if (!shouldShowGuildGiveaway) {
    return null
  }

  return <GuildGiveawayBanner theatricalSlug={theatricalSlug} className={className} />
}
